import axios from "axios";

export const lookupGrids = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API}/Lookup/grids`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
